module.exports = __webpack_public_path__ + "media/images/emblems/Acquarossa-coat_of_arms-4506e339d875350dffe8bec2003e8b7a.svg";